import { createAction } from 'redux-actions';

import { FETCH_PAGINATED_TEMPLATES } from '~/actions/names';
import { createFulfilledToolkitAction } from '~/actions/helpers';

export const setPaginatedTemplatesPage = createAction(
  'app/SET_PAGINATED_TEMPLATES_PAGE'
);

export const setPaginatedTemplatesType = createAction(
  'app/SET_PAGINATED_TEMPLATES_TYPE'
);

export const setPaginatedTemplatesSearch = createAction(
  'app/SET_PAGINATED_TEMPLATES_SEARCH'
);

export const clearPaginatedTemplatesTableOptions = createAction(
  'app/CLEAR_PAGINATED_TEMPLATED_TABLE_OPTIONS'
);

export const resetPaginatedTemplates = createAction(
  'app/RESET_PAGINATED_TEMPLATES'
);

export const setIsLoading = createAction('app/SET_IS_LOADING');

export const fetchPaginatedTemplatesSuccess = createFulfilledToolkitAction(
  FETCH_PAGINATED_TEMPLATES
);
